<template>
    <div class="join_container">
        <div id="background">
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[0], transition: 'background-color 0.2s' }">
                <div id="join_title">아이디</div>
                <input class="join_round_box_id" type="text" placeholder="2~12글자(특수문자 사용불가)" v-model="state.user_id" />
                <button id="id_btn" @click="CheckID()">중복 확인</button>
            </div>
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[1], transition: 'background-color 0.2s' }">
                <div id="join_title">닉네임</div>
                <input class="join_round_box_id" type="text" placeholder="2~12글자" v-model="state.nickname" />
                <button id="id_btn" @click="CheckNick()">중복 확인</button>
            </div>
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[2], transition: 'background-color 0.2s' }">
                <div id="join_title">비밀번호</div>
                <input class="join_round_box" type="password" placeholder="6자리 이상 영문/숫자/특수문자" v-model="state.password"/>
            </div>
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[3], transition: 'background-color 0.2s' }">
                <div id="join_title">비밀번호 확인</div>
                <input class="join_round_box" type="password" placeholder="" v-model="state.password_confirm"/>
            </div>
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[4], transition: 'background-color 0.2s' }">
                <div id="join_title">연락처</div>
                <input class="join_round_box" type="text" placeholder="'-'없이 숫자만 입력" v-model="state.phone" @input="validateNumberInput"/>
            </div>
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[5], transition: 'background-color 0.2s' }">
                <div id="join_title">계좌정보</div>
                <div class="join_acc_round_box">
                    <select id="bank_drop" v-model="selectedOption" @change="DropChange()" :class="dropdownClass">
                        <option value="default" class="styled-option" selected disabled hidden>은행 선택...</option>
                        <option value="경남은행" class="styled-option">경남은행</option>
                        <option value="광주은행" class="styled-option">광주은행</option>
                        <option value="국민은행" class="styled-option">국민은행</option>
                        <option value="기업은행" class="styled-option">기업은행</option>
                        <option value="농협중앙은행" class="styled-option">농협중앙은행</option>
                        <option value="농협회원조합" class="styled-option">농협회원조합</option>
                        <option value="대구은행" class="styled-option">대구은행</option>
                        <option value="도이치은행" class="styled-option">도이치은행</option>
                        <option value="부산은행" class="styled-option">부산은행</option>
                        <option value="산림은행" class="styled-option">산림은행</option>
                        <option value="산업은행" class="styled-option">산업은행</option>
                        <option value="상호저축은행" class="styled-option">상호저축은행</option>
                        <option value="새마을금고" class="styled-option">새마을금고</option>
                        <option value="수협중앙회" class="styled-option">수협중앙회</option>
                        <option value="신한금융투자" class="styled-option">신한금융투자</option>
                        <option value="신한은행" class="styled-option">신한은행</option>
                        <option value="신협중앙회" class="styled-option">신협중앙회</option>
                        <option value="외환은행" class="styled-option">외환은행</option>
                        <option value="우리은행" class="styled-option">우리은행</option>
                        <option value="우체국" class="styled-option">우체국</option>
                        <option value="전북은행" class="styled-option">전북은행</option>
                        <option value="제주은행" class="styled-option">제주은행</option>
                        <option value="카카오뱅크" class="styled-option">카카오뱅크</option>
                        <option value="토스뱅크" class="styled-option">토스뱅크</option>
                        <option value="하나은행" class="styled-option">하나은행</option>
                        <option value="한국시티은행" class="styled-option">한국시티은행</option>
                        <option value="HSBC은행" class="styled-option">HSBC은행</option>
                        <option value="K뱅크" class="styled-option">K뱅크</option>
                        <option value="SC제일은행" class="styled-option">SC제일은행</option>
                    </select>
                </div>
                <input class="join_acc_round_box" type="text" placeholder="이름(예금주)" v-model="state.bank_name"/>
            </div>
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[5], transition: 'background-color 0.2s' }">
                <div id="join_title"></div>
                <input class="join_round_box" type="text" placeholder="계좌 번호 (숫자만 입력)" v-model="state.bank_account" @input="validateNumberInput"/>
            </div>
            <div class="join_line_container" :style="{ backgroundColor: objectStyles[6], transition: 'background-color 0.2s' }">
                <div id="join_title">추천코드</div>
                <input class="join_round_box" type="text" placeholder="추천인이 있는 경우 입력" v-model="state.referee"/>
            </div>
            <button id="btn" @click="TryJoin()" style="">회원가입</button>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/reactivity'
import Swal from "sweetalert2";
import store from '../../js/store.js'
import API from '@/components/js/API';

export default {
        name: "popup_join",
        data() {
            return {
                isError: false,
                id_check: false,
                nick_check: false,
                phone_check: false,
                selectedOption: 'default',
                state: reactive({
                    user_id: '',
                    password: '',
                    nickname: '',
                    phone: '',
                    referee: '',
                    bank_account: '',
                    bank_name: '',
                    password_confirm: '',
                }),
                form:{},
                account_info: {
                    id: null,
                    nickname: null,
                    grade: '',
                    cash: 0,
                    credit: 0,
                    point: 0,
                    account: -1,
                    phone: '',
                    token: null
                },
                objectStyles: [
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                    'rgba(0, 0, 0, 0)',
                ],
                bgColor: 'rgba(0, 0, 0, 0)'
            }
        },
        computed: {
            dropdownClass() {
                return {
                    'default-style': this.selectedOption === 'default',
                    'other-style': this.selectedOption !== 'default'
                };
            }
        },
        methods:{
            isNullOrEmpty(str) {
                return !str || !str.trim();
            },
            CheckingSpecialText(str) {
                const pattern = /[^a-zA-Z0-9]/;
                return pattern.test(str);
            },
            DropChange: function(){
                const selectElement = document.getElementById('bank_drop');
                const selectedIndex = selectElement.selectedIndex;
                const selectedValue = selectElement.options[selectedIndex].value;
                
                this.state.bank_code = selectedValue;
            },
            CheckID: function()
            {
                if (!this.isNullOrEmpty(this.state.user_id))
                {
                    var inputID = this.state.user_id.trim();
                    if (inputID.length < 2 || inputID.length > 12) {
                        Swal.fire({
                            title: '중복 확인',
                            icon: 'error',
                            text: '아이디는 2~12자로 작성해야 합니다.',
                        }).then(this.id_check = false);
                        return;
                    }
                    if (this.CheckingSpecialText(inputID)) {
                        Swal.fire({
                            title: '사용 불가 문자',
                            icon: 'error',
                            text: '아이디에 특수문자는 사용하실 수 없습니다.',
                        }).then(this.id_check = false);
                        return;
                    }
                    this.form = {
                        user_id : this.state.user_id
                    }
                    API.AxiosPost('api/member/checkId', this.form, true,
                        (res) => {
                            console.log(res);
                            if (res.status == 200) {
                                switch (res.data.code) {
                                    case '200':
                                        this.id_check = true;
                                        Swal.fire({
                                            title: '중복 확인',
                                            icon: 'success',
                                            text: '사용 가능한 아이디입니다.',
                                        }).then(this.ClearLine(0));
                                        break;
                                    default:
                                    case '301':
                                        this.id_check = false;
                                        Swal.fire({
                                            title: '중복 확인',
                                            icon: 'error',
                                            text: '사용할 수 없는 아이디입니다.',
                                        });
                                        break;
                                }
                            }
                        }
                    );
                }
            },
            CheckNick: function()
            {
                if (!this.isNullOrEmpty(this.state.nickname))
                {
                    var inputNick = this.state.nickname.trim();
                    if (inputNick.length < 2 ||inputNick.length > 12) {
                        Swal.fire({
                            title: '중복 확인',
                            icon: 'error',
                            text: '닉네임은 2~12자로 작성해야 합니다.',
                        }).then(this.nick_check = false);
                        return;
                    }
                    this.form = {
                        nickname : this.state.nickname
                    }
                    API.AxiosPost('api/member/checkNick', this.form, true,
                    (res) => {
                            console.log(res);
                            if (res.status == 200) {
                                switch (res.data.code) {
                                    case '200':
                                        this.nick_check = true;
                                        Swal.fire({
                                            title: '중복 확인',
                                            icon: 'success',
                                            text: '사용 가능한 닉네임입니다.',
                                        }).then(this.ClearLine(0));
                                        break;
                                    default:
                                    case '301':
                                        this.nick_check = false;
                                        Swal.fire({
                                            title: '중복 확인',
                                            icon: 'error',
                                            text: '이미 사용 중인 닉네임입니다.',
                                        });
                                        break;
                                }
                            }
                        }
                    )
                }
            },
            TryJoin() {
                if(this.state.nickname.length == 0)
                {
                    Swal.fire({
                        title: '아이디 오류',
                        icon: 'error',
                        text: '아이디는 공백일 수 없습니다.',
                    }).then(this.AlertLine(0));
                    return;
                }
                else
                    this.ClearLine(0);

                if (!this.id_check)
                {
                    Swal.fire({
                        title: '아이디 오류',
                        icon: 'error',
                        text: '아이디 중복을 확인해야 합니다.',
                    }).then(this.AlertLine(0));
                    return;
                }
                else
                    this.ClearLine(0);

                    
                if(this.state.nickname.length == 0)
                {
                    Swal.fire({
                        title: '닉네임 오류',
                        icon: 'error',
                        text: '닉네임은 공백일 수 없습니다.',
                    }).then(this.AlertLine(1));
                    return;
                }
                else
                    this.ClearLine(1);

                if(this.nick_check == false)
                {
                    Swal.fire({
                        title: '닉네임 오류',
                        icon: 'error',
                        text: '닉네임 중복을 확인해야 합니다.',
                    }).then(this.AlertLine(1));
                    return;
                }

                if(this.state.password.length == 0)
                {
                    Swal.fire({
                        title: '비밀번호 오류',
                        icon: 'error',
                        text: '비밀번호는 공백일 수 없습니다.',
                    }).then(this.AlertLine(2));
                    return;
                }
                else
                    this.ClearLine(2);

                if(this.state.password != this.state.password_confirm || this.state.password_confirm.length == 0)
                {
                    Swal.fire({
                        title: '비밀번호 오류',
                        icon: 'error',
                        text: '비밀번호가 일치하지 않습니다.',
                    }).then(this.AlertLine(3));
                    return;
                }
                else
                    this.ClearLine(3);

                if(this.state.phone.length == 0)
                {
                    Swal.fire({
                        title: '연락처 오류',
                        icon: 'error',
                        text: '연락처는 공백일 수 없습니다.',
                    }).then(this.AlertLine(4));
                    return;
                }
                else
                    this.ClearLine(4);

                if(this.state.bank_code == '' || this.state.bank_account.length == 0 || this.state.bank_name.length == 0)
                {
                    Swal.fire({
                        title: '계좌 정보 오류',
                        icon: 'error',
                        text: '계좌 정보는 반드시 입력하셔야 합니다.',
                    }).then(this.AlertLine(5));
                    return;
                }
                else
                    this.ClearLine(5);

                
                this.form =
                {
                    memberId: this.state.user_id,
                    nickname: this.state.nickname,
                    account: this.state.bank_code + "/" + this.state.bank_account.trim() + "/" + this.state.bank_name.trim(),
                    password: this.state.password,
                    phone: this.state.phone,
                    referralId: this.state.referee
                }
                API.AxiosPost('api/member/register', this.form, true,
                (res) => {
                        console.log(res);
                        if (res.status == 200) {
                            switch (res.data.code) {
                                case '200':
                                    Swal.fire({
                                        title: '회원가입 완료',
                                        icon: 'success',
                                        html: res.data.message,
                                        confirmButtonText: '확인'
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            this.$root.ClosePopup();
                                        }
                                    })
                                
                                    break;
                                case '311':
                                    Swal.fire({
                                        title: '추천코드 오류',
                                        icon: 'error',
                                        text: '존재하지 않는 추천코드 입니다.',
                                    }).then(this.AlertLine(6));
                                    break;
                                case '405':
                                    Swal.fire({
                                        title: '서버점검',
                                        icon: 'error',
                                        text: '서버점검 중 입니다.',
                                    });
                                    break;
                                default:
                                Swal.fire({
                                        title: '진행오류',
                                        icon: 'error',
                                        html: '정상적으로 진행되지 않았습니다.<br>잠시 후 다시 시도해 주세요.',
                                    });
                            }
                        }
                    }
                )
            },

            login_try: function () {
                this.form = {
                    user_id : this.state.user_id,
                    password : this.state.password
                }
                API.AxiosPost('users/logIn', this.form, true,
                (res) => {
                        console.log(res);
                        if (res.status == 200) {
                            switch (res.data.code) {
                                case '200':
                                    store.commit('setUser', res.data.data)
                                    store.commit('setGameSettings', res.data.data.game_settings);

                                    this.login_success();
                                    break;
                                case '301':
                                    Swal.fire({
                                        icon: 'error',
                                        text: '해당 계정은 이미 접속 중이므로 중복 접속할 수 없습니다.',
                                    })
                                    break;
                                case '997':
                                    Swal.fire({
                                        icon: 'error',
                                        text: res.data.data,
                                    })
                                    break;
                                case '996':
                                    Swal.fire({
                                        icon: 'error',
                                        text: res.data.data,
                                    })
                                    break;
                                case '306':
                                    Swal.fire({
                                        icon: 'error',
                                        text: '접속 제한회원입니다. 운영팀에 문의하십시요.',
                                    })
                                    break;
                                case '307':
                                case '318':
                                    Swal.fire({
                                        icon: 'error',
                                        text: '아이디나 비밀번호를 확인하십시요.',
                                    })
                                    break;
                            }
                        }
                        else {
                            console.log("return code : " + res.data.code);
                        }
                    }
                )
            },

            login_success: function () {
                this.$root.sendMessage('join room')
                this.$root.ClosePopup();
            },
            
            
            getObjectStyle(index) {
                // 객체의 스타일을 반환하는 메서드
                return this.objectStyles[index];
            },
            AlertLine(index) {
                // objectStyle 객체를 새로운 스타일로 교체
                this.objectStyles[index] = 'rgba(255, 0, 0, 0.4)';
            },
            ClearLine(index){
                this.objectStyles[index] = 'rgba(0, 0, 0, 0)';
            },
            MakeJoinForm(){
                this.form = 
                {
                    user_id : this.state.user_id,
                    nickname : this.state.nickname,
                    account : this.state.bank_code + "/" + this.state.bank_account.trim() + "/" + this.state.bank_name.trim(),
                    password : this.state.password,
                    phone : this.state.phone,
                    referralId : this.state.referee
                }
            },
            validateNumberInput(event) {
                event.target.value = event.target.value.replace(/[^0-9]/g, '');
                // 수동으로 입력 값 갱신
                this.$emit('input', event.target.value);
            }
        }
    }
</script>

<style>
.join_container {
    width: 550px;
    max-height: calc(100vh - 200px);

    margin: 0px auto;
    padding: 20px 20px 20px 20px;
}

.join_line_container{
    width: 470px;
    height: 50px;
    padding: 5px;
    border-radius: 5px 5px 5px 5px / 5px 5px 5px 5px;
    transition: background-color 0.5s ease;
}
#join_title{
    float: left;
    width: 120px;
    height: 100%;
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-align: left;
    margin-top: 10px;
    margin-right: 10px;
    margin-left: 10px;
}
.join_round_box_id{
    background-color: white;
    float: left;
    height: 40px;
    width: 210px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-bottom: 10px;
    margin-right: 10px;
    padding-left: 20px;
    padding-top: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.join_round_box_id::placeholder{
    font-size: 13px;
    font-style: italic;
}
.join_round_box{
    background-color: white;
    float: left;
    height: 40px;
    width: 300px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-bottom: 10px;
    margin-right: 20px;
    padding-left: 20px;
    padding-top: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.join_round_box::placeholder{
    font-size: 13px;
    font-style: italic;
}
.join_acc_round_box{
    background-color: white;
    float: left;
    height: 40px;
    width: 140px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-bottom: 10px;
    margin-right: 20px;
    padding-left: 20px;
    padding-top: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.join_acc_round_box::placeholder{
    font-size: 13px;
    font-style: italic;
}
#bank_drop{
    float: left;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    padding-bottom: 2px;
    outline: 0px;
    height: 100%;
    width: 95%;
    border: 1px;
    padding-top: 0px;
}
#btn{
    width: 250px;
    height: 40px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
#id_btn{
    width: 80px;
    height: 100%;
    border: 1px;
    margin-right: 20px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-top: 0px;
    margin-bottom: 10px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    font-size: 13px;
}
.color-change {
    width: 100px;
    height: 100px;
    
}
.styled-option{
    font-size: 15px;
    font-style: normal;
    color: black;
}
.default-style {
    font-size: 13px;
    font-style: italic;
    color: grey;
}

/* 기본값이 아닌 경우에 적용될 스타일 */
.other-style {
    font-size: 15px;
    font-style: normal;
    color: black;
}
</style>@/components/js/API.js